import { useApi } from '@/shared/api/http';

export const useDeliveryService = () => {
  const api = useApi();

  const getPickUpPoints = async (isAuth = false) => {
    try {
      return await api.get<any>('/pickup-points/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении локаций пунктов выдачи:', error);
      throw error;
    }
  };

  return {
    getPickUpPoints,
  };
};
